const appUserAgentRegEx = /NAVER\([inapp|higgs]+;[^0-9]*(search|pay|navershopping|navershoppingbrowser);[^0-9]*(\d+);[^0-9]*(\d+.\d+.\d+).*\)/im;
const nativeAppUserAgentRegEx = /nApps \((iOS|Android OS) ([^;]+);([^;]+);([^;]+);(\d+\.\d+\.\d+)(?:\.\d+)?(?:;GDOT)?\)/;
const XWhaleAgentRegEx = /com.nhn.android.search/im;
const NaverRealEstateAppRegEx = /naverland_android|naverland_ios/i;
const OldInternetExplorerEx = /(?:ms|\()(ie) ([\w\\.]+)/i;
const NewInternetExplorerEx = /trident.+rv[: ]([\w\\.]{1,9})\b.+like gecko/i;
const APP_SCHEME = {
  NAVER: 'naversearchapp',
  PAY: 'naverpayapp'
};

/**
 * 안드로이드 중, intent url에 포함되는 package name
 */
const PACKAGE_NAME = {
  NAVER: 'com.nhn.android.search',
  PAY: 'com.naverfin.payapp'
};
const NAVER_APP_DOWNLOAD_LINK = {
  ANDROID: `market://details?id=${PACKAGE_NAME.NAVER}&hl=ko`,
  IOS: 'https://itunes.apple.com/kr/app/id393499958?mt=8'
};
const PAY_APP_DOWNLOAD_LINK = {
  IOS: 'itms-apps://itunes.apple.com/app/id1554807824',
  IOS_WEB: 'https://itunes.apple.com/kr/app/id1554807824?mt=8',
  ANDROID: `market://details?id=${PACKAGE_NAME.PAY}`
};
const API_ROUTES = {
  NELO: {
    MSS: '/api/nelo/mss'
  }
};
const NAVER_SIGN_CODE = {
  SUCCESS: 1000,
  // 정상 기기
  LOW_OS: 1001,
  // Android 버전이 6 미만인 경우, iOS의 버전이 10 미만인 경우
  NO_USIM: 1002,
  // 유심이 없는 경우,
  JAIL_BREAK: 1003,
  // 기기탈옥 및 변조,
  TEE_NOT_SUPPORTED: 1006 // TEE가 존재하지 않는 기기 (TEE의 정의는 https://en.wikipedia.org/wiki/Trusted_execution_environment)
};

/**
 * 워치앱 UA
 * @description https://oss.fin.navercorp.com/FinancialFE/front-apigw/blob/59a379a0303fafae8585d248f114d907ea54bb3d/src/common/accessInfo.js#L36-L46
 */
// nApps (watchOS 8.4.2;Watch6,9;NaverPayWatch;1.10.0.5)
const PAY_APP_WATCH_OS_NATIVE_AGENT = /nApps ?\(watchOS.+;.+;NaverPayWatch;.+\)/i;

// nApps (Android OS 11;SM-R865N;NaverPayWatch;1.10.0-qa05)
const PAY_APP_WEAR_OS_NATIVE_AGENT = /nApps ?\(Android.+;.+;NaverPayWatch;.+\)/i;

// nApps (WatchOS 7;Watch7,1;NaverSearchWatch;11.12.5)
const NAVER_APP_WATCH_OS_NATIVE_AGENT = /nApps ?\(WatchOS.+;.+;NaverSearchWatch;.+\)/i;

// nApps (Android OS 11;SM-R865N;NaverSearchWatch;1.1.0)
const NAVER_APP_WEAR_OS_NATIVE_AGENT = /nApps ?\(Android.+;.+;NaverSearchWatch;.+\)/i;

export { API_ROUTES, APP_SCHEME, NAVER_APP_DOWNLOAD_LINK, NAVER_APP_WATCH_OS_NATIVE_AGENT, NAVER_APP_WEAR_OS_NATIVE_AGENT, NAVER_SIGN_CODE, NaverRealEstateAppRegEx, NewInternetExplorerEx, OldInternetExplorerEx, PACKAGE_NAME, PAY_APP_DOWNLOAD_LINK, PAY_APP_WATCH_OS_NATIVE_AGENT, PAY_APP_WEAR_OS_NATIVE_AGENT, XWhaleAgentRegEx, appUserAgentRegEx, nativeAppUserAgentRegEx };
